var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g"},[_c('div',{staticClass:"g__col g__col-12"},[_c('button',{staticClass:"btn btn--primary btn--block wrapper",on:{"click":_vm.toggleMobileFilters}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }